import React, { useState, ChangeEvent } from "react";
import RD_QUERY from "./queries/RD_QUERY";
import { useParams } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { Form, Button } from "react-bootstrap";
import EDIT_RD_MUTATION from "./queries/EDIT_RD_MUTATION";
import Loading from "../../common/Loading";
import AlertDismissible from "../../common/AlertDismissible";
import { removeTypename } from "../../utils";

const EditRD = () => {
  const [ec, setEC] = useState("");
  const [ecEmail, setECEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [group, setGroup] = useState<number>();
  const [lookupId, setLookupId] = useState("");
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const { id }: { id?: string } = useParams();
  const getEditedData = () => {
    const changed = {
      ...data?.regionalDirector,
      name:
        firstName && lastName
          ? `${firstName} ${lastName}`
          : data?.regionalDirector.name,
      phone: phone || data?.regionalDirector.phone,
      lookup_id: lookupId || data?.regionalDirector.lookup_id,
      first_name: firstName || data?.regionalDirector.first_name,
      last_name: lastName || data?.regionalDirector.last_name,
      group: group || data?.regionalDirector.group,
      event_coordinator: ec || data?.regionalDirector.event_coordinator,
      event_coordinator_email:
        ecEmail || data?.regionalDirector.event_coordinator_email,
    };
    delete changed.createdAt;
    delete changed.updatedAt;
    delete changed.warehouse;
    return removeTypename(changed);
  };
  const { data, loading } = useQuery(RD_QUERY, {
    variables: { id: id },
  });
  const [editRD] = useMutation(EDIT_RD_MUTATION, {
    variables: {
      rd: {
        ...getEditedData(),
      },
    },
    onCompleted: (res) => {
      setSaving(false);
      setSuccess(true);
    },
    refetchQueries: [
      {
        query: RD_QUERY,
        variables: { id: id },
      },
    ],
  });
  const renderPost = () => {
    return (
      <Form>
        {loading && (
          <div className="mt-4 mb-4">
            <Loading />
          </div>
        )}
        {success && (
          <AlertDismissible
            variant="success"
            dismissible
            onClose={() => setSuccess(false)}
            className="mt-4"
          >
            Post Saved.
          </AlertDismissible>
        )}
        {data && (
          <>
            <Form.Group className="mt-4" id="rdFirstNameControl">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={(event: ChangeEvent<any>) => {
                  const changed: string = event.target.value || "";
                  setFirstName(changed);
                }}
                placeholder="RD First Name"
                defaultValue={data?.regionalDirector?.first_name}
                type="text"
              />
            </Form.Group>
            <Form.Group className="mt-4" id="rdLastNameControl">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                onChange={(event: ChangeEvent<any>) => {
                  const changed: string = event.target.value || "";
                  setLastName(changed);
                }}
                placeholder="RD Last Name"
                defaultValue={data?.regionalDirector?.last_name}
                type="text"
              />
            </Form.Group>
            <Form.Group className="mt-4" id="rdFirstNameControl">
              <Form.Label>Lookup ID</Form.Label>
              <Form.Control
                onChange={(event: ChangeEvent<any>) => {
                  const changed: string = event.target.value || "";
                  setLookupId(changed);
                }}
                placeholder="RD Lookup ID"
                defaultValue={data?.regionalDirector?.lookup_id}
                type="text"
              />
            </Form.Group>
            <Form.Group className="mt-4" id="rdFirstNameControl">
              <Form.Label>Group</Form.Label>
              <Form.Control
                onChange={(event: ChangeEvent<any>) => {
                  const changed: number = parseFloat(event.target.value) || 0;
                  setGroup(changed);
                }}
                placeholder="RD Group"
                defaultValue={data?.regionalDirector?.group}
                type="text"
              />
            </Form.Group>
            <Form.Group className="mt-4" id="rdPhoneControl">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                onChange={(event: ChangeEvent<any>) => {
                  const changed: string = event.target.value || "";
                  setPhone(changed);
                }}
                placeholder="RD Phone"
                defaultValue={data?.regionalDirector?.phone}
                type="tel"
              />
            </Form.Group>
            <Form.Group className="mt-4" id="rdECControl">
              <Form.Label>Event Coordinator</Form.Label>
              <Form.Control
                onChange={(event: ChangeEvent<any>) => {
                  const changed: string = event.target.value || "";
                  setEC(changed);
                }}
                placeholder="Event Coordinator"
                defaultValue={data?.regionalDirector?.event_coordinator}
                type="text"
              />
            </Form.Group>
            <Form.Group className="mt-4" id="rdECEmailControl">
              <Form.Label>Event Coordinator Email</Form.Label>
              <Form.Control
                onChange={(event: ChangeEvent<any>) => {
                  const changed: string = event.target.value || "";
                  setECEmail(changed);
                }}
                placeholder="EC Email"
                defaultValue={data?.regionalDirector?.event_coordinator_email}
                type="text"
              />
            </Form.Group>
          </>
        )}

        <Button
          disabled={saving || loading}
          variant="primary"
          className="mt-4"
          onClick={() => {
            editRD();
            setSaving(true);
          }}
        >
          Save Changes
        </Button>
      </Form>
    );
  };
  return <div>{renderPost()}</div>;
};

export default EditRD;
